import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container",
  id: "main"
}
const _hoisted_2 = { class: "wp420" }
const _hoisted_3 = { class: "crest" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "crestText flex" }
const _hoisted_6 = ["alt", "src"]
const _hoisted_7 = { class: "formBox" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "copy" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Cookies = _resolveComponent("Cookies")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'Home' }))),
        class: "flex logo"
      }, [
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.storageUrl + '/logo.png',
            alt: _ctx.$t('city.app_name')
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("img", {
            class: "city",
            alt: _ctx.$t('city.app_name'),
            src: _ctx.storageUrl + '/cityName.svg'
          }, null, 8, _hoisted_6)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_view)
      ]),
      _hoisted_8
    ]),
    _createVNode(_component_Cookies)
  ]))
}